<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="300px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja sygnalnych produktu
                </h1>
            </v-card-title>

            <v-card-text>
                <v-row dense class="my-0">
                    <v-col cols="4" class="text-right font-weight-bold mt-2">
                        Sygnalne:
                    </v-col>
                    <v-col cols="8">
                        <v-text-field
                            v-model="orderProduct.signalAmount"
                            type="number"
                            min="0"
                            :error-messages="valueErrors()"
                            dense
                            required
                            outlined
                            reverse
                            @input="changeSignalAmount"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer, minValue } from 'vuelidate/lib/validators'

export default {
    name: 'ProductSignalAmountDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        orderProductData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            orderProduct: {
                signalAmount: 0
            },
            originalSignalAmount: 0
        }
    },
    validations() {
        const self = this

        return {
            orderProduct: {
                signalAmount: {
                    required,
                    integer,
                    minValue: minValue(0),
                    notLessThanOriginal: function(value) {
                        if (value === null || value === undefined || value === '') return false

                        return Number(value) >= self.originalSignalAmount
                    }
                }
            }
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.orderProduct = JSON.parse(JSON.stringify(this.orderProductData))
                this.originalSignalAmount = this.orderProductData?.signalAmount || 0
            }
        }
    },
    methods: {
        changeSignalAmount(value) {
            const numValue = Number(value ?? 0) || 0

            this.orderProduct.signalAmount = numValue
        },
        valueErrors() {
            const errors = []

            if (!this.$v.orderProduct.signalAmount || !this.$v.orderProduct.signalAmount.$dirty) {
                return errors
            }

            !this.$v.orderProduct.signalAmount.required && errors.push('Proszę podać sygnalne.')
            !this.$v.orderProduct.signalAmount.integer && errors.push('Proszę podać liczbę naturalną.')
            if (!this.$v.orderProduct.signalAmount.minValue) {
                errors.push('Wartość nie może być ujemna.')
            }
            if (!this.$v.orderProduct.signalAmount.notLessThanOriginal) {
                errors.push(`Wartość nie może być mniejsza niż ${this.originalSignalAmount}.`)
            }

            return errors
        },
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.$emit('on-save', this.orderProduct)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.orderProduct = {
                    signalAmount: 0
                }
                this.originalSignalAmount = 0
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>
